<script setup>
	import SaveIcon from "./SaveIcon.vue";
	import { VBtn } from "vuetify/components";

	const props = defineProps({
		class: Array,
		disabled: Boolean
	});
	const emit = defineEmits([ "click" ]);

	function raiseClickEmit() {
		emit("click");
	}
</script>

<template>
	<VBtn title="Save and Close"
		:class="props.class.concat(['mx-2', 'save-action'])"
		:disabled="props.disabled"
		@click="raiseClickEmit">
		<SaveIcon/>
	</VBtn>
</template>
